<template>
  <div class="collapse">
    <div class="collapse_header">
      <el-autocomplete
        v-model="val"
        :fetch-suggestions="search"
        placeholder="请输入论文篇名"
        @select="handleSelect"
      >
        <template slot-scope="props">
          <div class="name">{{ props.item.title }}</div>
        </template>
      </el-autocomplete>
      <el-button
        type="primary"
        @click="addPaper"
        v-if="code === 'J' || code === 'I' || code === 'E' "
      >+手动输入添加</el-button>
    </div>
    <div class="collapse_screen" v-if="code === 'J' && Object.keys(subjectList).length">
      <el-button type="primary" @click="showScreen = !showScreen">{{showScreen?'隐藏列表':'展开列表'}}</el-button>
      <div class="screen" v-if="showScreen">
        <el-tag
          v-for="(item,index) in subjectList"
          :key="index"
          :effect="item.choose?'dark':'plain'"
          :closable="item.choose"
          @click="clkName(index)"
          @close="closeName(index)"
          type="info"
        >{{item.subject}}</el-tag>
      </div>
    </div>
    <div class="collapse_body">
      <el-input placeholder="请输入项目名字" v-model="schfilter"></el-input>
      <el-table border :data="tables" style="width: 100%" ref="dataTable">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="专利名称" show-overflow-tooltip v-if="code === 'P'"></el-table-column>
        <el-table-column prop="title" label="项目名字" show-overflow-tooltip v-else-if="code === 'O'"></el-table-column>
        <el-table-column prop="title" label="书名" show-overflow-tooltip v-else-if="code === 'B'"></el-table-column>
        <el-table-column prop="title" label="成果名称" show-overflow-tooltip v-else-if="code === 'A'"></el-table-column>
        <el-table-column prop="title" label="会议名" show-overflow-tooltip v-else-if="code === 'C'"></el-table-column>
        <el-table-column prop="title" label="论文名" show-overflow-tooltip v-else-if="code === 'D'"></el-table-column>
        <el-table-column prop="title" label="篇名" show-overflow-tooltip v-else></el-table-column>

        <el-table-column prop="patentNo" label="专利号" show-overflow-tooltip v-if="code === 'P'"></el-table-column>
        <el-table-column
          prop="creatorAll"
          label="项目承担人"
          show-overflow-tooltip
          v-else-if="code === 'O'"
        ></el-table-column>
        <el-table-column
          prop="creatorAll"
          label="作者"
          show-overflow-tooltip
          v-else-if="code === 'B'"
        ></el-table-column>
        <el-table-column prop="year" label="年份" show-overflow-tooltip v-else-if="code === 'A'"></el-table-column>
        <el-table-column
          prop="creatorAll"
          label="作者"
          show-overflow-tooltip
          v-else-if="code === 'C'"
        ></el-table-column>
        <el-table-column
          prop="creatorAll"
          label="作者"
          show-overflow-tooltip
          v-else-if="code === 'D'"
        ></el-table-column>
        <el-table-column prop="creatorAll" label="作者" show-overflow-tooltip v-else></el-table-column>

        <el-table-column prop="applicationNo" label="申请号" show-overflow-tooltip v-if="code === 'P'"></el-table-column>
        <el-table-column
          prop="projectNo"
          label="项目编号"
          show-overflow-tooltip
          v-else-if="code === 'O'"
        ></el-table-column>
        <el-table-column prop="language" label="语言" show-overflow-tooltip v-else-if="code === 'B'"></el-table-column>
        <el-table-column
          prop="creatorAll"
          label="奖励人"
          show-overflow-tooltip
          v-else-if="code === 'A'"
        ></el-table-column>
        <el-table-column prop="language" label="语言" show-overflow-tooltip v-else-if="code === 'C'"></el-table-column>
        <el-table-column prop="tutor" label="导师" show-overflow-tooltip v-else-if="code === 'D'"></el-table-column>
        <el-table-column prop="journal" label="刊名" show-overflow-tooltip v-else></el-table-column>
        <el-table-column prop="institute" label="申请机构" show-overflow-tooltip v-if="code === 'P'"></el-table-column>
        <el-table-column label="年/期" show-overflow-tooltip v-else-if="code === 'O'">
          <template slot-scope="scope">{{scope.row.year}}/{{scope.row.Issue?scope.row.issue:'-'}}</template>
        </el-table-column>
        <el-table-column prop="year" label="出版年" show-overflow-tooltip v-else-if="code === 'B'"></el-table-column>
        <el-table-column prop="name" label show-overflow-tooltip v-else-if="code === 'A'"></el-table-column>
        <el-table-column prop="year" label="年份" show-overflow-tooltip v-else-if="code === 'C'"></el-table-column>
        <el-table-column
          prop="instituteAll"
          label="机构"
          show-overflow-tooltip
          v-else-if="code === 'D'"
        ></el-table-column>
        <el-table-column label="年/期" show-overflow-tooltip v-else>
          <template slot-scope="scope">{{scope.row.year}}/{{scope.row.Issue?scope.row.issue:'-'}}</template>
        </el-table-column>

        <el-table-column prop="isbn" label="ISBN号" show-overflow-tooltip v-if="code === 'B'"></el-table-column>
        <el-table-column prop="year" label="年份" show-overflow-tooltip v-else-if="code === 'D'"></el-table-column>

        <!-- <el-table-column prop="address" label="地址" type></el-table-column>
        <el-table-column prop="name" label="书名" type v-else-if="code === 'B'"></el-table-column>-->
      </el-table>
      <div class="btn">
        <el-button center type="primary" @click="getSelected()">保存</el-button>
      </div>
    </div>
    <el-dialog title="上传论文" :visible.sync="dialogFormVisible" center>
      <el-form :model="form" :rules="rules" ref="form" :label-width="formLabelWidth">
        <el-form-item label="篇名" prop="title">
          <el-input v-model="form.title" autocomplete="off" placeholder="请输入篇名"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="creatorAll">
          <el-input v-model="form.creatorAll" autocomplete="off" placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="刊名" prop="journal">
          <el-input v-model="form.journal" autocomplete="off" placeholder="请输入刊名"></el-input>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input v-model="form.year" autocomplete="off" placeholder="请输入年份"></el-input>
        </el-form-item>
        <el-form-item label="URL" prop="url">
          <el-input v-model="form.url" autocomplete="off" placeholder="请输入URL"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { allresource } from '@/api/claim'
export default {
  name: 'collapse',
  props: {
    tableData: {
      type: Array
    }, // 传入的成果列表
    code: {
      type: String
    }, // 传入的成果类型
    subjectList: {
      type: Array
    } // 传入的学科
  },
  components: {},
  watch: {
    subjectList: {
      deep: true,
      handler () {
        this.getSubject()
        // this.loading1 = false
      }
    },
    dialogFormVisible: {
      deep: true,
      handler () {
        this.form = {
          title: '',
          creatorAll: '',
          journal: '',
          year: '',
          url: '',
          Checked: true,
          creatorStandard: '',
          ResourceCode: this.code
        }
      }
    }
  },
  data () {
    return {
      schfilter: '', // 查询关键词
      showScreen: true, // 学科显示隐藏
      subject: [], // 选中学科
      // 上传论文弹窗
      dialogFormVisible: false,
      val: '', // 论文关键词
      searchList: [], // 搜索到论文
      // 上传论文表单
      form: {
        title: '',
        creatorAll: '',
        journal: '',
        year: '',
        url: '',
        Checked: true,
        creatorStandard: '',
        ResourceCode: this.code
      },
      // 表单标签宽度
      formLabelWidth: '120px',
      // 表单规则
      rules: {
        title: [{ required: true, message: '请输入篇名', trigger: 'blur' }],
        creatorAll: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ],
        journal: [{ required: true, message: '请输入刊名', trigger: 'blur' }],
        year: [{ required: true, message: '请输入年份', trigger: 'blur' }],
        url: [{ required: true, message: '请输入URL', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 搜索
    search (index, cb) {
      let temp = [this.code]
      let data = {
        c: temp,
        term: this.val
      }
      allresource(data).then(res => {
        this.searchList = res.data
        cb(this.searchList)
      })
    },
    // 选中搜索到的内容
    handleSelect (item) {
      this.tableData.push(item)
      this.$refs.dataTable.toggleRowSelection(this.tableData[this.tableData.length - 1])
    },
    // 设置每个学科都为未选中
    getSubject () {
      this.subjectList.forEach((item, index) => {
        this.subjectList[index].choose = false
      })
    },
    // 选择学科
    clkName (index) {
      if (this.subjectList[index].choose === true) {
        return
      }
      this.subjectList[index].subject = this.subjectList[index].subject + ''
      this.subject.push(this.subjectList[index].subject)
      this.subjectList[index].choose = true
      this.getData()
    },
    // 取消选中学科
    closeName (index) {
      this.subjectList[index].choose = false
      let i = this.subject.findIndex(item => {
        if (item === this.subjectList[index].subject) {
          return true
        }
      })
      this.subject.splice(i, 1)
      this.getData()
    },
    // 获取数据
    getData () {
      this.$emit('screenData', this.subject)
    },
    // 上传弹窗显示
    addPaper () {
      this.dialogFormVisible = true
    },
    // 上传表单提交
    submitForm (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.creatorStandard = this.form.creatorAll
          this.tableData.push(this.form)
          this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },

    // 保存
    getSelected () {
      let data = {
        tableData: this.$refs.dataTable.selection,
        code: this.code
      }
      this.$emit('saveData', data)
    }
  },
  computed: {
    // 模糊搜索
    tables () {
      const search = this.schfilter
      if (search) {
        return this.tableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            return (
              String(dataNews[key])
                .toLowerCase()
                .indexOf(search.toLowerCase()) > -1
            )
          })
        })
      }
      return this.tableData
    }
  }
}
</script>

<style lang="scss">
.collapse {
  height: 560px;
  .collapse_header {
    display: flex;
    .el-autocomplete {
      margin: auto;
      width: 50%;
    }
  }
  .collapse_screen {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    .el-button {
      width: 10%;
    }
    .screen {
      display: flex;
      width: 80%;
      margin-left: 5%;
      align-items: center;
      .el-tag{
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }
  .collapse_body {
    margin-top: 15px;
    border: 1px solid #bfbfbf;
    padding: 15px;
    .el-input {
      width: 100%;
    }
    .el-table {
      margin-top: 15px;
      overflow: auto;
      height: 300px;
      .el-table__row {
        height: 50px;
      }
    }
    .btn {
      margin-top: 15px;
      text-align: center;
      .el-button {
        width: 9rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/claim/collapse.vue